module.exports = __webpack_public_path__ + "static/media/download.c327a126.svg";